module.exports = __webpack_public_path__ + "static/media/one.89a232f2.svg";